export function DeletingChip() {
  return (
    <span className="label label-warning" style={{ fontSize: 12 }}>
      <i className="fas fa-trash" aria-hidden="true" /> Deleting{' '}
      <i className="fas fa-spinner fa-pulse" aria-hidden="true" />
    </span>
  );
}
